// src/config/brands/uvex.js

// Brand color constants
const UVEX_THEME_PRIMARY = '#ff6600';
const BLACK = '#1d1d1d';
const NEUTRAL_DARK = '#272727';
const BOLD_FONT_FAMILY = 'NHaasGroteskTXW01-75Bd';

export const uvexBrandConfig = {
    isAurex: false,
    title: 'uvex high-fit Otocheck',
    favicon: 'favicon-uvex.ico',
    appleTouchIcon: 'Logos/uvex/apple-touch-icon.png',
    theme: {
        primaryColor: '#00349A',
        secondaryColor: '#ea1e1e',
        backgroundColor: '#f1f1f1'
    },
    fonts: {
        primary: 'NeueHaasGroteskText W01',
        display: 'Neue Haas Grotesk Disp W0535XL',
        bold: BOLD_FONT_FAMILY,
        mono: 'Droid Sans Mono',
        letterSpacing: '0px',
        textFontFamily: BOLD_FONT_FAMILY,
    },
    fontFiles: [
        {
            family: 'Neue Haas Grotesk Disp W0535XL',
            src: "url('Fonts/uvex/54648c18-4881-459e-813e-2d62f5af89d9.woff2') format('woff2'), url('Fonts/uvex/bb16bb0a-cb62-4087-b188-2ee4dc8b818c.woff') format('woff')"
        },
        {
            family: 'NeueHaasGroteskText W01',
            src: "url('Fonts/uvex/a14594bf-73de-4b5f-9792-9566994a021d.woff2') format('woff2'), url('Fonts/uvex/bb4a10bb-155d-4c1a-a813-c65e10fac36c.woff') format('woff')"
        },
        {
            family: 'NHaasGroteskTXW01-75Bd',
            src: "url('Fonts/uvex/d13fb250-6b64-4d97-85df-51fc6625a891.woff2') format('woff2'), url('Fonts/uvex/60fa2ce6-c35e-4203-9bbf-25dd128daec5.woff') format('woff')"
        },
        {
            family: 'Droid Sans Mono',
            src: "url('Fonts/DroidSansMono.ttf')"
        }
    ],
    logos: {
        main: 'Logos/uvex/uvex-logo.png',
        icon: 'Logos/uvex/uvex.svg'
    },
    companyInfo: {
        name: 'uvex',
        fullName: 'uvex safety group',
        website: 'https://www.uvex.com'
    },
    manifest: {
        name: 'uvex high-fit Otocheck',
        short_name: 'OTOCheck',
        description: 'uvex high-fit Otocheck',
        icons: [
            {
                src: 'Logos/uvex/OTOCheck_96x96.png',
                sizes: '96x96',
                type: 'image/png'
            },
            {
                src: 'Logos/uvex/OTOCheck_144x144.png',
                sizes: '144x144',
                type: 'image/png'
            },
            {
                src: 'Logos/uvex/OTOCheck_192x192.png',
                sizes: '192x192',
                type: 'image/png'
            }
        ],
        start_url: '.',
        display: 'standalone',
        theme_color: '#000000',
        background_color: '#ffffff'
    },
    ui: {
        topMenu: {
            backgroundColor: 'white',
            borderColor: '#d2d2d2',
            logoHeight: '20px',
            avatar: {
                textColor: 'inherit',
                fontSize: '12px',
            }
        },
        navMenu: {
            backgroundColor: BLACK,
            toggleActionsColor: NEUTRAL_DARK,
            plusButtonBackgroundColor: UVEX_THEME_PRIMARY,
            offlineTestResultBackgroundColor: BLACK,
            offlineTestResultFontColor: 'inherit',
            rootColor: 'inherit',
            cssCustomProperties: {
                '--nav-background-color': '#2a2a2a', // lighten(#1d1d1d, 5%)
            },
        },
        test: {
            instructionFontSize: '35px',
        },
        fluentTheme: {
            themePrimary: UVEX_THEME_PRIMARY,
            themeLighterAlt: '#fff9f5',
            themeLighter: '#ffe7d6',
            themeLight: '#ffd1b3',
            themeTertiary: '#ffa366',
            themeSecondary: '#ff781f',
            themeDarkAlt: '#e65c00',
            themeDark: '#c24e00',
            themeDarker: '#8f3900',
            neutralLighterAlt: '#faf9f8',
            neutralLighter: '#f3f2f1',
            neutralLight: '#edebe9',
            neutralQuaternaryAlt: '#e1dfdd',
            neutralQuaternary: '#d0d0d0',
            neutralTertiaryAlt: '#c8c6c4',
            neutralTertiary: '#c2c2c2',
            neutralSecondary: '#858585',
            neutralPrimaryAlt: '#4b4b4b',
            neutralPrimary: '#333333',
            neutralDark: NEUTRAL_DARK,
            black: BLACK,
            white: '#ffffff',
            red: '#ea1e1e',
            blue: '#00349A',
            green: '#12B361',
            lightGrey: '#666666',
            transparentGrey: '#000'
        }
    }
};
